"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicates = void 0;
function removeDuplicates(retVal) {
    retVal = retVal.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
    return retVal;
}
exports.removeDuplicates = removeDuplicates;
//# sourceMappingURL=general-utils.js.map